import { bl_fi_xtn_gen_doc_line_itn_doc_line_matching_balance_RowClass, bl_fi_xtn_gen_doc_line_itn_doc_line_matching_balance_RowInterface } from "../../dbschema/bl_fi_xtn_gen_doc_line_itn_doc_line_matching_balance.model";
import { BaseContainerModel } from "../base-container.model";

export class ExternalGenDocLineItnDocLineMatchingBalanceContainerModel extends BaseContainerModel{
  bl_fi_xtn_gen_doc_line_itn_doc_line_matching_balance: bl_fi_xtn_gen_doc_line_itn_doc_line_matching_balance_RowInterface = new bl_fi_xtn_gen_doc_line_itn_doc_line_matching_balance_RowClass();
}
